import { Injectable } from '@angular/core';

import { APP_CONFIG } from '../../app.config';
import { Authority } from '../../shared/enums/authority.enum';
import { UserStatus } from '../../shared/enums/user-status.enum';
import { Error } from '../../shared/models/error.model';
import { User } from '../../shared/models/user.model';
import { RequestService } from '../../shared/services/request.service';

@Injectable()
export class UserPageService {
  constructor(private requestService: RequestService) {}

  getStoreUser(storeId: number): Promise<Array<User>> {
    return new Promise((resolve, reject) => {
      const urlRequest: string =
        this.requestService.buildUrlPathParams(
          { storeId: storeId },
          APP_CONFIG.WEBSERVICE.STORE_USERS
        ) +
        '?status=' +
        UserStatus.ACTIVE['code'] +
        ',' +
        +UserStatus.DRAFT['code'];

      this.requestService.getData(urlRequest).then(
        (response: Array<User>) => {
          const users: Array<User> = [];
          if (response && response.length > 0) {
            response.forEach((u: User) => {
              users.push(new User(u));
            });
          }
          resolve(users);
        },
        (error: Error) => {
          console.log(error);
          reject(error);
        }
      );
    });
  }

  saveStoreUser(user: User, storeId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      const urlRequest: string = this.requestService.buildUrlPathParams(
        { storeId: storeId },
        APP_CONFIG.WEBSERVICE.STORE_USERS
      );
      this.requestService.postData(urlRequest, user.toJson(false)).then(
        (response: any) => {
          resolve(response);
        },
        (error: Error) => {
          console.log(error);
          reject(error);
        }
      );
    });
  }

  updateStoreUser(user: User, storeId: number, updateOnlyName: boolean): Promise<any> {
    return new Promise((resolve, reject) => {
      const urlRequest: string = this.requestService.buildUrlPathParams(
        { storeId: storeId },
        APP_CONFIG.WEBSERVICE.STORE_USERS
      );
      this.requestService.putData(urlRequest, user.toJson(updateOnlyName)).then(
        (response: any) => {
          resolve(response);
        },
        (error: Error) => {
          console.log(error);
          reject(error);
        }
      );
    });
  }

  removeStoreUser(userId: number, storeId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      const urlRequest: string = this.requestService.buildUrlPathParams(
        { storeId: storeId },
        APP_CONFIG.WEBSERVICE.STORE_USERS
      );
      this.requestService.deleteData(urlRequest + '/' + userId).then(
        (response: any) => {
          resolve(response);
        },
        (error: Error) => {
          console.log(error);
          reject(error);
        }
      );
    });
  }

  getAuthorizationList(authority: Authority, isForPlace: boolean): Array<Authority> {
    if (authority === Authority.MANAGER) {
      return this.getAuthorities(isForPlace).filter(
        (a: Authority) => a !== Authority.MANAGER && a !== Authority.ADMIN
      );
    }
    return this.getAuthorities(isForPlace);
  }

  getAuthorities(isForPlace: boolean): Array<Authority> {
    if (isForPlace) {
      return [
        Authority.ADMIN,
        // Authority.DELIVERYMAN
      ];
    }
    return [
      Authority.ADMIN,
      Authority.MANAGER,
      Authority.ATTENDANT,
      Authority.KITCHEN,
      Authority.WAITER,
      Authority.DELIVERYMAN,
    ];
  }

  // PLACE SERVICES
  // ------------------------

  getPlaceUser(placeId: number): Promise<Array<User>> {
    return new Promise((resolve, reject) => {
      const urlRequest: string =
        this.requestService.buildUrlPathParams(
          { placeId: placeId },
          APP_CONFIG.WEBSERVICE.PLACE_USERS
        ) +
        '?status=' +
        UserStatus.ACTIVE['code'] +
        ',' +
        +UserStatus.DRAFT['code'];

      this.requestService.getData(urlRequest).then(
        (response: Array<User>) => {
          const users: Array<User> = [];
          if (response && response.length > 0) {
            response.forEach((u: User) => {
              users.push(new User(u));
            });
          }
          resolve(users);
        },
        (error: Error) => {
          console.log(error);
          reject(error);
        }
      );
    });
  }

  savePlaceUser(user: User, placeId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      console.log(user.toUserPlaceJson(false));
      const urlRequest: string = this.requestService.buildUrlPathParams(
        { placeId: placeId },
        APP_CONFIG.WEBSERVICE.PLACE_USERS
      );
      this.requestService.postData(urlRequest, user.toUserPlaceJson(false)).then(
        (response: any) => {
          resolve(response);
        },
        (error: Error) => {
          console.log(error);
          reject(error);
        }
      );
    });
  }

  updatePlaceUser(user: User, placeId: number, updateOnlyName: boolean): Promise<any> {
    return new Promise((resolve, reject) => {
      const urlRequest: string = this.requestService.buildUrlPathParams(
        { placeId: placeId },
        APP_CONFIG.WEBSERVICE.PLACE_USERS
      );
      this.requestService.putData(urlRequest, user.toUserPlaceJson(updateOnlyName)).then(
        (response: any) => {
          resolve(response);
        },
        (error: Error) => {
          console.log(error);
          reject(error);
        }
      );
    });
  }

  removePlaceUser(userId: number, placeId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      const urlRequest: string = this.requestService.buildUrlPathParams(
        { placeId: placeId },
        APP_CONFIG.WEBSERVICE.PLACE_USERS
      );
      this.requestService.deleteData(urlRequest + '/' + userId).then(
        (response: any) => {
          resolve(response);
        },
        (error: Error) => {
          console.log(error);
          reject(error);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/user/user-page.service.ts